import { Box } from '@mantine/core';
import type { CSSProperties } from 'react';
import classes from './MaskedSidebarVideo.module.css';

type Props = {
  opacity?: number;
  scaleX?: number;
};

export function MaskedSidebarVideo({ opacity, scaleX }: Props) {
  const style: CSSProperties = {};
  if (opacity !== undefined) style.opacity = opacity;
  if (scaleX !== undefined) style.transform = `scaleX(${scaleX})`;

  return (
    <Box className={classes.videoWrapper}>
      <video
        autoPlay
        loop
        muted
        playsInline
        className={classes.maskedVideo}
        style={Object.keys(style).length === 0 ? undefined : style}
      >
        <source src="/sidebar-background.mp4" type="video/mp4" />
      </video>
    </Box>
  );
}
